export default __webpack_public_path__ + "static/media/ArrowAngRight.393e391a.svg";